import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { AuctionService, LoaderService } from '../../../services';
import { AuctionDetail, AuctionLocation } from '../../../models';
import constants from '../../../utility/constants';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';
import { AuthenticationService } from './../../../services/authentication.service';
import messages from '../../../utility/messages';
import { environment } from '../../../../environments/environment';
import { MatMenu } from '@angular/material/menu';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-view-auction',
  templateUrl: './view-auction.component.html',
  styleUrls: ['./view-auction.component.css'],
})
export class ViewAuctionComponent implements OnInit {
  @ViewChild('listingMenu') listingMenu: MatMenu;

  modalRef: BsModalRef;
  submitLoader: boolean = false;
  // one step back
  returnUrl: string = '../';
  upcomingAuctions: any;
  approveCommonForm: FormGroup;
  disableCommonRegistrationButton: boolean = true;
  lots: Array<any>;
  pageNumber: number = 1;
  totalLots: number;
  pageSize: number = 10;
  currentUrl: string = '../';
  editUrl: string = '../';
  auctionCode: string;
  forAdmin: boolean = true;
  auctionStatuses = constants.common.auctionStatus;
  registrationFormat = constants.common.saletypeRegistrationFormat;
  displaySection = constants.common.displaySection;
  roles = constants.common.role;
  isLoading: boolean = true;

  showMatMenu: boolean = true;
  private subscriptions: Array<Subscription> = [];
  imagesSlider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.custom-lot .thumbs',
  };

  thumbnailsSlider = {
    slidesToShow: 8,
    slidesToScroll: 1,
    asNavFor: '.custom-lot .image-slides',
    arrows: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
  };

  imagesSlider2 = {
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.view-more-slider .thumbs',
  };

  thumbnailsSlider2 = {
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    asNavFor: '.view-more-slider .image-slides2',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  openModalLotImages(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(
        {},
        {
          class:
            'custom-popup lot-images-slider modal-dialog modal-dialog-centered',
        }
      )
    );
  }

  openLink(url) {
    window.open(url, '_blank');
  }

  openLotsLink(url) {
    window.open(url + '#check', '_blank');
  }

  openModalViewMore(template3: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template3,
      Object.assign(
        {},
        {
          class:
            'custom-popup lot-images-slider modal-dialog modal-dialog-centered',
        }
      )
    );
  }

  showLocationDetail(locationId: number, template: TemplateRef<any>) {
    this.location = this.auctionDetail.auctionLocations.find(
      (item) => item.id == locationId
    );

    this.modalRef = this.modalService.show(
      template,
      Object.assign(
        {},
        {
          class:
            'custom-popup location-details modal-dialog modal-dialog-centered',
        }
      )
    );
  }

  openModalLocationDetails(template2: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template2,
      Object.assign(
        {},
        {
          class:
            'custom-popup location-details modal-dialog modal-dialog-centered',
        }
      )
    );
  }

  displayedColumns: string[] = ['locationName', 'address', 'lot', 'status'];

  displayedColumns2: string[] = [
    'lotNum',
    'lotDescription',
    'location',
    'startingDate',
    'lotEndDate',
    'currentBid',
    'lotImages',
  ];

  displayedColumns3: string[] = ['locationName', 'address', 'lot', 'status'];

  // step number
  stepActive = 1;

  showView: boolean = false;

  auctionDetail: AuctionDetail = null;
  auctionId: number;
  location: AuctionLocation = null;
  websiteUrl: string = environment.websiteUrl;

  constructor(
    private auctionService: AuctionService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private authenticateService: AuthenticationService
  ) {
    this.currentUrl = router.url;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.auctionId = +params['id'];
      this.auctionCode = params['auctionCode'];

      if (!isNaN(this.auctionId)) {
        this.forAdmin = true;
        this.getAuction(this.auctionId);
      }

      if (this.auctionCode != undefined) {
        this.forAdmin = false;
        this.getAuctionByCode();
      }
    });

    this.approveCommonForm = new FormGroup({
      auctionId: new FormControl(''),
      syncWithAuctionId: new FormControl(''),
    });
  }

  private checkMenu() {
    const allitems = this.listingMenu._allItems.changes.subscribe((res: any) => {
      this.showMatMenu = res?.length > 0;
    });
    this.subscriptions.push(allitems);
  }

  goToEdit() {
    this.router.navigate(['edit'], {
      relativeTo: this.route,
    });
  }

  goToBack(numberOfStepsBack: number = 1) {
    this.route.queryParams.subscribe((res) => {
      let param = res['returnTo'];
      if (param) {
        this.router.navigateByUrl(param);
        return;
      } else {
        let routeFragments = this.router.url.split('/');
        let returnUrl = routeFragments
          .splice(0, routeFragments.length - numberOfStepsBack)
          .join('/');
        if (this.auctionDetail.auctionStatus == 1) {
          this.router.navigate([returnUrl], {
            relativeTo: this.route,
            queryParams: { type: 'live' },
          });
        } else if (this.auctionDetail.auctionStatus == 2) {
          this.router.navigate([returnUrl], {
            relativeTo: this.route,
            queryParams: { type: 'upcoming' },
          });
        } else if (this.auctionDetail.auctionStatus == 4) {
          this.router.navigate([returnUrl], {
            relativeTo: this.route,
            queryParams: { type: 'recent' },
          });
        } else {
          this.router.navigate([returnUrl], {
            relativeTo: this.route,
            queryParams: { type: 'pending' },
          });
        }
      }
    });
  }

  getAuction(auctionId: number) {
    this.isLoading = true;
    const aucDetails = this.auctionService.getAuctionDetail(auctionId).subscribe(
      (response) => {
        this.auctionDetail = response;
        this.checkMenu();
        this.isLoading = false;
      },
      (err) => {
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.isLoading = false;
        this.goToBack();
      }
    );
    this.subscriptions.push(aucDetails);
  }

  getAuctionByCode() {
    const detailCode = this.auctionService.getAuctionDetailByCode(this.auctionCode).subscribe(
      (response) => {
        this.auctionDetail = response;
        this.showView = true;
      },
      (err) => {
        this.showView = true;
        this.toastr.error(
          err,
          constants.common.toast.errorTitle,
          constants.common.toast.config
        );
        this.goToBack();
      }
    );
    this.subscriptions.push(detailCode);
  }

  auctionStartRegistration(id) {
    this.submitLoader = true;
    const startRegistration = this.auctionService.auctionStartRegistration({ id: id }).subscribe(() => {
      this.getAuction(id);
      this.submitLoader = false;
      this.modalService.hide();
      this.toastr.success(
        messages.auctionListing.auctionStartRegistration,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
    });
    this.subscriptions.push(startRegistration);
  }

  closeModal() {
    this.modalService.hide();
  }

  auctionStopRegistration(id) {
    this.submitLoader = true;
    const stopRegister = this.auctionService.auctionStopRegistration({ id: id }).subscribe(() => {
      this.getAuction(id);
      this.submitLoader = false;
      this.modalService.hide();
      this.toastr.success(
        messages.auctionListing.auctionStopRegistration,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
    });
    this.subscriptions.push(stopRegister);
  }
  markItFeatured(id) {
    let formData = new FormGroup({
      id: new FormControl(''),
      updatedBy: new FormControl(''),
    });
    formData.patchValue({ id: id });
    formData.patchValue({
      updatedBy: this.authenticateService.currentUserValue()?.user?.id,
    });
    const mfeature = this.auctionService.markItFeatured(formData.value).subscribe(() => {
      this.getAuction(id);
      this.toastr.success(
        messages.auctionListing.markItFeatured,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
    });
    this.subscriptions.push(mfeature);
  }
  markAsSold(id) {
    const msold = this.auctionService.markAsSold({ id: id }).subscribe(() => {
      this.getAuction(id);
      this.toastr.success(
        messages.auctionListing.markItFeatured,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
    });
    this.subscriptions.push(msold);
  }
  stopSyncRegistrationWithOtherAuction(id) {
    const stopsync = this.auctionService
      .stopSyncRegistrationWithOtherAuction({ id: id })
      .subscribe(() => {
        this.getAuction(id);
        this.toastr.success(
          messages.auctionListing.stopSyncRegistrationWithOtherAuction,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
      });
      this.subscriptions.push(stopsync);
  }

  startCommonAuctionRegistration(template: TemplateRef<any>, id: number) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({
        backdrop: 'static',
        keyboard: false,
        class:
          'custom-popup activate-modal activate-lmodal text-left modal-dialog modal-dialog-centered approve-auction',
      })
    );
    this.getUpcomingAuctions(id);
  }
  getUpcomingAuctions(id) {
    const uauctions = this.auctionService.getUpcomingAuctions(id).subscribe(
      (res) => {
        this.upcomingAuctions = res;
      },
      () => {}
    );
    this.subscriptions.push(uauctions);
  }

  syncRegistrationWithOtherAuction() {
    this.approveCommonForm.patchValue({ auctionId: this.auctionDetail.id });
    this.approveCommonForm.patchValue({
      syncWithAuctionId: this.approveCommonForm.get('syncWithAuctionId').value,
    });
    const rothers = this.auctionService
      .syncRegistrationWithOtherAuction(this.approveCommonForm.getRawValue())
      .subscribe(() => {
        this.submitLoader = false;
        this.getAuction(this.auctionId);
        this.approveCommonForm.reset();
        this.modalRef.hide();
        this.toastr.success(
          messages.auctionListing.startSyncRegistrationWithOtherAuction,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
      });
    this.subscriptions.push(rothers);
    const sregister = this.auctionService
      .syncRegistrationWithOtherAuction(this.approveCommonForm.getRawValue())
      .subscribe(() => {
        this.submitLoader = false;
        this.approveCommonForm.reset();
        this.modalRef.hide();
        this.toastr.success(
          messages.auctionListing.startSyncRegistrationWithOtherAuction,
          constants.common.toast.successTitle,
          constants.common.toast.config
        );
      });
      this.subscriptions.push(sregister);
  }

  upcomingAuctionChange(value: string) {
    this.disableCommonRegistrationButton = Number(value) > 0 ? false : true;
  }

  goToUsers() {
    this.router.navigate(['./', 'users'], {
      relativeTo: this.route,
      queryParams: {
        returnTo: this.router.url,
      },
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  goToBidders() {
    this.router.navigate(['./', 'bids', 'bidder'], {
      relativeTo: this.route,
      queryParams: {
        returnTo: this.router.url,
      },
    });
  }
}
